import { Theme } from '../theme.types'
import { BaseColor, ColorShade, repairPalette } from '../palette'
import baseTheme from './sharedBase'
import { darkAbsoluteColors, darkStatusPalettes } from './sharedColors'

const mipasaDarkTheme: Theme = {
  ...baseTheme,
  palette: repairPalette({
    absolute: darkAbsoluteColors,
    ...darkStatusPalettes,

    base: {
      [BaseColor.min]: '#000000',
      [BaseColor.shade_0]: '#0F0F10',
      [BaseColor.shade_10]: '#1D1D20',
      [BaseColor.shade_15]: '#262629',
      [BaseColor.shade_20]: '#2E2E33',
      [BaseColor.shade_30]: '#3F3F45',
      [BaseColor.shade_40]: '#52525A',
      [BaseColor.shade_50]: '#6E6E75',
      [BaseColor.shade_60]: '#A2A2A8',
      [BaseColor.shade_70]: '#D4D4D8',
      [BaseColor.shade_80]: '#E4E4E7',
      [BaseColor.shade_90]: '#F4F4F5',
      [BaseColor.shade_100]: '#FAFAFA',
      [BaseColor.max]: '#FFFFFF',
      [BaseColor.surfaceBg]: '#2E2E33',
      [BaseColor.overlay]: '#0F0F10',
    },

    primary: {
      [ColorShade.foreground]: '#FFFFFF',
      [ColorShade.softest]: '#13512A',
      [ColorShade.softer]: '#136D34',
      [ColorShade.soft]: '#13893E',
      [ColorShade.semiSoft]: '#13A548',
      [ColorShade.color]: '#13C152',
      [ColorShade.semiStrong]: '#42CD75',
      [ColorShade.strong]: '#71DA97',
      [ColorShade.stronger]: '#A1E6BA',
      [ColorShade.strongest]: '#D8F5E2',
    },
  }),
}

export default mipasaDarkTheme
